import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { NiceModalComponent } from "components/context/NiceModalProvider";
import ActionView from "models/actions/ActionView";

export default NiceModal.create(({ id, ...props }) => {
  const modal = useModal();

  return (
    <NiceModalComponent open={modal.visible} onClose={modal.hide}>
      <ActionView {...props} actionId={id} onCancel={modal.hide} />
    </NiceModalComponent>
  );
});
